const pageNameKey = "ticketSupportForMachineRowIconButton";

export const ticketSupportForMachineRowIconButtonEn = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "Request Technical Support",
  },
};

export const ticketSupportForMachineRowIconButtonPtBr = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "Solicitar suporte técnico",
  },
};

export const ticketSupportForMachineRowIconButtonDe = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "Technischen Support anfordern",
  },
};

export const ticketSupportForMachineRowIconButtonZhHans = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "请求技术支持",
  },
};

export const ticketSupportForMachineRowIconButtonIt = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "Richiedi supporto tecnico",
  },
};

export const ticketSupportForMachineRowIconButtonEs = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "Solicitar soporte técnico",
  },
};

export const ticketSupportForMachineRowIconButtonNl = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "Technische-support aanvragen",
  },
};

export const ticketSupportForMachineRowIconButtonTr = {
  [pageNameKey]: {
    goToRequestTechnicalSupport: "Teknik Destek Talebi",
  },
};
